module.exports = __webpack_public_path__ + "static/media/Lexington-Green-By-Laws.6c354120.pdf";